export default [
  {
    path: '/sites',
    name: 'sites',
    component: () => import('@/views/Sites/Sites.vue'),
    meta: {
      pageTitle: 'Sites',
      breadcrumb: [
        {
          text: 'Sites',
          active: true,
        },
      ],
    },
  },
  {
    path: '/site/:id',
    component: () => import('@/views/Sites/Site/Site.vue'),
    name: 'site',
    meta: {
      pageTitle: 'Site',
      breadcrumb: [
        {
          text: 'Site',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sites/addsite',
    name: 'addsite',
    component: () => import('@/views/Sites/AddNewSite/AddSite.vue'),
    meta: {
      pageTitle: 'Add Site',
      breadcrumb: [
        {
          text: 'Add Site',
          active: true,
        },
      ],
    },
  },
]
